// extracted by mini-css-extract-plugin
export default {"container":"CountryInfos_container__mGlyd","content":"CountryInfos_content__m1IUt","row":"CountryInfos_row__so+fL","col":"CountryInfos_col__r3aEK"};